export class File {
  constructor(public url: string) {
    this.url = url;
  }

  get name(): string | null {
    return this.url ? this.url.substring(this.url.lastIndexOf('/') + 1, this.url.lastIndexOf('.')) : null;
  }

  get icon(): string {
    const ext = this.url ? this.url.substring(this.url.lastIndexOf('.') + 1) : null;
    switch (ext) {
      case 'pdf':
        return 'icon-pdf';
      case 'ppt':
        return 'icon-ppt';
      default:
        return 'icon-docs';
    }
  }
}
